const getBasePath = () => {
  const buildTimeBasePath = window.env?.REACT_APP_PUBLIC_BASE_PATH;
  if (buildTimeBasePath && buildTimeBasePath !== '/') {
    return buildTimeBasePath;
  }
  const pathname = window.location.pathname;
  const prRegex = /^(\/PR\d+)/;
  const prMatch = prRegex.exec(pathname);
  if (prMatch) {
    return prMatch[1];
  }
  return '';
};

const base = getBasePath().replace(/\/$/, '');
const origin = window.env.REACT_APP_B2C_REDIRECT_URL.replace(/\/$/, '');

export const b2cConfig = {
  auth: {
    clientId: window.env.REACT_APP_B2C_AZURE_CLIENT_ID,
    authority: window.env.REACT_APP_B2C_AUTHORITY,
    redirectUri: `${origin}${base}/`,
    knownAuthorities: [window.env.REACT_APP_B2C_KNOWNAUTHORITIES]
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" to save cache in cookies to address trusted zones limitations in IE (see: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/Known-issues-on-IE-and-Edge-Browser)
  }
};

export const b2cLoginRequest = {
  scopes: ['openid', 'profile', 'offline_access', window.env.REACT_APP_B2C_SCOPE] // B2C scopes
};

// offline_access
